import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { injectIntl } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';

import { authenticateUser } from 'src/auth';
import FlashesRenderer from 'src/components/Flashes/FlashesRenderer';
import Loading from 'src/components/Loading';
import AdminNavigation from 'src/components/Navigation/AdminNavigation';
import Footer from 'src/enosikit/components/Footer';
import { USER_TYPE_ADMIN } from 'src/util/constants';

/**
 * Description
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {object} props.router
 * @param {object} props.viewer
 * @param {object} props.intl
 * @returns {React.ReactComponentElement} - AdminLayout component
 */
function AdminLayout({
  children, router, viewer = null, intl,
}) {
  if (!authenticateUser(intl, viewer, USER_TYPE_ADMIN, router)) {
    return <Loading />;
  }

  const pageTitle = intl.formatMessage({ id: 'layout.admin_layout.page.title', defaultMessage: 'Enosi Administration' });

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageTitle}</title>
      </Helmet>

      <div className="flex flex-column" style={{ minHeight: '80vh' }}>
        <AdminNavigation viewer={viewer} />

        <section id="main">
          <FlashesRenderer />
          <div className="container">
            <div className="flex-auto">{children}</div>
          </div>
        </section>

        <Footer versionUI={VERSION} />
      </div>
    </>
  );
}

AdminLayout.propTypes = {
  intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  router: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
  viewer: PropTypes.shape({
    id: PropTypes.string,
    viewerUser: PropTypes.shape({
      type: PropTypes.string,
      uuid: PropTypes.string,
    }),
  }), // eslint-disable-line react/forbid-prop-types
};

export default createFragmentContainer(
  injectIntl(AdminLayout),
  {
    viewer: graphql`
      fragment AdminLayout_viewer on Viewer @relay(mask: false) {
        id
        viewerUser {
          uuid,
          type
        }
        ...AdminNavigation_viewer
      }
    `,
  },
);
